import { countries } from '@alfalab/data';

const formatCountry = ([_, name, iso2, dialCode, priority, areaCodes]) => ({
    name,
    iso2,
    dialCode,
    priority,
    areaCodes: areaCodes !== null && areaCodes !== void 0 ? areaCodes : null,
});
const getCountries = () => countries.map(formatCountry).sort((a, b) => a.name.localeCompare(b.name));
const getCountriesHash = () => countries.reduce((acc, country) => {
    const iso2 = country[2];
    acc[iso2] = formatCountry(country);
    return acc;
}, {});

export { getCountries, getCountriesHash };
